import { appI18n } from '@flowus/common/i18n';
import { GroupLevel, GroupSortType } from '@next-space/fe-api-idl';

export const GroupSortMap: Record<
  'text' | 'date' | 'number',
  { type: GroupSortType; name: string }[]
> = {
  text: [
    {
      type: GroupSortType.MANUAL,
      name: appI18n.t('bitable.group.sort_manual'),
    },
    {
      type: GroupSortType.ASCENDING,
      name: appI18n.t('common.ascending'),
    },
    {
      type: GroupSortType.DESCENDING,
      name: appI18n.t('common.descending'),
    },
  ],
  date: [
    {
      type: GroupSortType.ASCENDING,
      name: appI18n.t('common.utils.date_ascending'),
    },
    {
      type: GroupSortType.DESCENDING,
      name: appI18n.t('common.utils.date_descending'),
    },
  ],
  number: [
    {
      type: GroupSortType.ASCENDING,
      name: appI18n.t('common.ascending'),
    },
    {
      type: GroupSortType.DESCENDING,
      name: appI18n.t('common.descending'),
    },
  ],
};

export const GroupLevelMap: Record<'text' | 'date', { type: GroupLevel; name: string }[]> = {
  date: [
    { type: GroupLevel.RELATIVE, name: appI18n.t('common.relative_date') },
    { type: GroupLevel.DAY, name: appI18n.t('common.day') },
    { type: GroupLevel.WEEK, name: appI18n.t('common.week') },
    { type: GroupLevel.MONTH, name: appI18n.t('common.month') },
    { type: GroupLevel.YEAR, name: appI18n.t('common.year') },
  ],
  text: [
    { type: GroupLevel.EXACT, name: appI18n.t('bitable.group.level_exact') },
    { type: GroupLevel.ALPHABET_PREFIX, name: appI18n.t('bitable.group.level_prefix') },
  ],
};
